import { HeadCellSortState } from '@foradevelopment/fora-ui';
import { PayrollReportHistoryRowViewModel } from '@fora-monorepo/employer-my-pages-common/types';

import type { ReportHistoryTableSortId } from '../types';
import { sortStringBasic, sortStringLocale } from './comparisonFunctions';

type TableSortState = {
  [key in ReportHistoryTableSortId]?: HeadCellSortState;
};

export const sortReportHistoryListIndices = ({
  reportHistoryList,
  sortState,
  indices,
}: {
  reportHistoryList: PayrollReportHistoryRowViewModel[];
  sortState: TableSortState;
  indices?: number[];
}): number[] => {
  const indicesToSort = indices ?? reportHistoryList.map((_, ind) => ind);

  if (Object.keys(sortState).every(state => !state)) {
    return indicesToSort;
  }

  return indicesToSort.sort((a: number, b: number) => {
    const reportHistoryA = reportHistoryList[a];
    const reportHistoryB = reportHistoryList[b];

    // Default sorting by date
    if (sortState.date) {
      return sortStringBasic(
        reportHistoryA.createdDate,
        reportHistoryB.createdDate,
        sortState.date === HeadCellSortState.Asc
      );
    }
    // Sorting by status
    if (sortState.status) {
      if (sortState.status) {
        return sortStringBasic(
          reportHistoryA.status,
          reportHistoryB.status,
          sortState.status === HeadCellSortState.Asc
        );
      }
    }
    // Sorting by admin full name
    if (sortState.administrator) {
      return sortStringLocale(
        reportHistoryA.adminReporterFullName ? reportHistoryA.adminReporterFullName : '',
        reportHistoryB.adminReporterFullName ? reportHistoryB.adminReporterFullName : '',
        sortState.administrator === HeadCellSortState.Asc
      );
    }

    return 0;
  });
};
